import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApiService } from '../../../shared/services/api.service';
import { UserManagementService } from '../../../shared/services/user-management.service';
import { GetPBDashboardConfigQuery, GetPBDashboardConfigQueryVariables, PBDashboardQueryInput } from '../../../../API';
import { GetPBDashboardConfig } from '../../../../graphql/queries';

@Component({
  selector: 'app-market-overview',
  templateUrl: './market-overview.component.html',
  styleUrl: './market-overview.component.scss',
})
export class MarketOverviewComponent implements OnInit {
  powerBiUrl!: SafeResourceUrl;
  clubCode!: string;
  isLoading = false;

  constructor(
    private apiService: ApiService,
    private nzMessageService: NzMessageService,
    private userManagementService: UserManagementService,
    private sanitizer: DomSanitizer,
  ) {
    this.clubCode = this.userManagementService.getOrgId();
  }

  ngOnInit(): void {
    this.getPowerBiDashboardConfig();
    console.log(' selectedClubCode in onInit() :', this.clubCode);
  }

  getPowerBiDashboardConfig() {
    this.isLoading = true;
    const clubCode = this.userManagementService.getOrgId();
    const pbDashboardQueryInput: PBDashboardQueryInput = {
      clubCode,
    };
    this.apiService
      .query<GetPBDashboardConfigQuery, GetPBDashboardConfigQueryVariables>(GetPBDashboardConfig, {
        input: pbDashboardQueryInput,
      })
      .then((response) => {
        const result = response.data?.GetPBDashboardConfig ?? null;

        if (result) {
          const { reportId, groupId, embedUrl } = result;
          if (!reportId?.trim() || !groupId?.trim() || !embedUrl?.trim()) {
            this.nzMessageService.error('Invalid Power BI configuration: Missing required fields');
            return;
          }

          const powerBiUrl = this.getPowerBiUrl(reportId, groupId, embedUrl!);
          this.powerBiUrl = this.sanitizer.bypassSecurityTrustResourceUrl(powerBiUrl);
        } else {
          this.nzMessageService.error('No Power BI dashboard config found');
        }
      })
      .catch((error) => {
        this.nzMessageService.error(`Failed to load PowerBi Dashboard ${error}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  getPowerBiUrl(reportId: string, groupId: string, embedUrl: string): string {
    return embedUrl.replace('{REPORTID}', reportId ?? '').replace('{GROUPID}', groupId ?? '');
  }
}
